import { useState } from "react";
import { ColorSwatch, Group, Text } from "@mantine/core";
import { AD_STATUS } from "@/Constants/adStatus";
import { FilterSelect } from "./FilterSelect";
import { useTranslation } from "react-i18next";
import classes from "./FilterSelect.module.css";

const ALL_STATUS_ICON = (
    <svg className={classes.icon} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#clip0_624_1034)">
            <path d="M14.6666 7.99998C14.6666 11.6818 11.6818 14.6666 7.99998 14.6666C4.31808 14.6666 1.33331 11.6818 1.33331 7.99998C1.33331 4.31808 4.31808 1.33331 7.99998 1.33331C11.6818 1.33331 14.6666 4.31808 14.6666 7.99998Z" stroke="#212529" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="2.67 2.67" />
        </g>
        <defs>
            <clipPath id="clip0_624_1034">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const AdStatusFilterSelect = ({ onChange, value: controlledValue, ...props }) => {
    const { t } = useTranslation();
    const options = [
        { value: '', label: t('adStatus.all') },
        { value: String(AD_STATUS.PUBLISHED.code), label: t('adStatus.delivering'), dotColor: AD_STATUS.PUBLISHED.color },
        { value: String(AD_STATUS.PAUSED.code), label: t('adStatus.paused'), dotColor: AD_STATUS.PAUSED.color },
        { value: String(AD_STATUS.EXPIRED.code), label: t('adStatus.expired'), dotColor: AD_STATUS.EXPIRED.color },
        { value: String(AD_STATUS.DONE.code), label: t('adStatus.ready'), dotColor: AD_STATUS.DONE.color },
        { value: String(AD_STATUS.DRAFT.code), label: t('adStatus.draft'), dotColor: AD_STATUS.DRAFT.color },
        { value: 'archived', label: t('adStatus.archive'), dotColor: AD_STATUS.ARCHIVED.color },
    ];
    const [value, setValue] = useState(controlledValue ?? '');
    const currentValue = controlledValue ?? value;
    const selectedOption = options.find((option) => option.value === currentValue);

    const handleChange = (val) => {
        setValue(val ?? '');
        onChange?.(val);
    };

    return (
        <FilterSelect
            placeholder={t('adStatus.all')}
            w={180}
            data={options}
            value={currentValue}
            leftSection={selectedOption?.dotColor
                ? <ColorSwatch color={selectedOption.dotColor} size={16} withShadow={false} />
                : ALL_STATUS_ICON}
            renderOption={({ option }) => (
                <Group gap={8} wrap="nowrap">
                    {option.dotColor && <ColorSwatch color={option.dotColor} size={8} withShadow={false} />}
                    <Text fz={14} fw={400} className={classes.optionText} c="var(--option-fg)">{option.label}</Text>
                </Group>
            )}
            onChange={handleChange}
            {...props}
        />
    );
};
